import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Merchant} from './gen';
import {resizeImageUrl} from './utils';

@Injectable({
  providedIn: 'root',
})
export class PrinterConfigService {
  private readonly _key = 'dposPrinterConfig';

  constructor(private router: Router) {}

  savePrinterConfig(isPrintHost) {
    let data = {
      date: new Date(),
      isPrintHost: isPrintHost
    }
    localStorage.setItem(this._key, JSON.stringify(data));
  }

  getPrinterConfig(): {date: Date, isPrintHost: boolean} {
    let userJson = localStorage.getItem(this._key);
    return JSON.parse(userJson) as {date: Date, isPrintHost: boolean} ;
  }

  clear() {
    localStorage.removeItem(this._key);
  }
}
